import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

interface ButtonProps {
  fixed: boolean;
}

export const Container = styled.div.attrs<any, ButtonProps>((): any => ({}))`
  display: flex;
  flex: 1;
  justify-content: flex-end;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 16px;
    ${({ fixed }) => {
      if (fixed) {
        return `
          width: 100%;
          align-items: center;
          justify-content: center;
          background-color: ${ColorPalette.HEX.White};
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
        `;
      }
    }}
  }
`;

export const ConfirmButton = styled(Button)`
  height: 56px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 350px;
  }
`;
